import React, { Component } from 'react';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import axios from "../../utils/axiosInstance";
import bookly from "../assets/Footer/logo.png";
import loading from "../assets/Footer/loading.png";
import './Header.css';

// Higher-Order Component to pass React Router v6 hooks into Class Component
function withRouter(Component) {
  return function ComponentWithRouterProp(props) {
    const navigate = useNavigate();
    const location = useLocation();
    return <Component {...props} router={{ navigate, location }} />;
  };
}

class BooklyHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenu: 'home',
      isProfileMenuOpen: false,
      isMobileMenuOpen: false,
      isAuthModalOpen: false,
      authStep: 'phone',
      countryCode: '+880',
      selectedFlag: '🇧🇩',
      isCountryDropdownOpen: false,
      countrySearch: '',
      phoneNumber: '',
      otp: ['', '', '', '', '', ''],
      timer: 48,
      isLoggedIn: !!localStorage.getItem('token'),
      loading: false,
      menuMode: 'guest', // 'guest' or 'host'
      isSwitchingMode: false,
      targetMode: null
    };

    this.otpRefs = Array(6).fill(0).map(() => React.createRef());
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.authStep === 'otp' && prevState.authStep !== 'otp') {
      this.startTimer();
    }
  }

  componentWillUnmount() {
    if (this.timerInterval) clearInterval(this.timerInterval);
  }

  startTimer = () => {
    this.setState({ timer: 48 });
    if (this.timerInterval) clearInterval(this.timerInterval);
    this.timerInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timer <= 0) {
          clearInterval(this.timerInterval);
          return { timer: 0 };
        }
        return { timer: prevState.timer - 1 };
      });
    }, 1000);
  };

  handleResendOtp = async () => {
    if (this.state.timer === 0) {
      this.setState({ otp: ['', '', '', '', '', ''], loading: true });
      const fullPhone = this.state.countryCode + this.state.phoneNumber;
      try {
        const res = await axios.post("/customer/send-otp", { phone: fullPhone });
        if (res.data.status === 'success') {
          this.startTimer();
          this.setState({ loading: false });
          setTimeout(() => {
            if (this.otpRefs[0].current) {
              this.otpRefs[0].current.focus();
            }
          }, 100);
        } else {
          alert(res.data.message || "Failed to resend OTP");
          this.setState({ loading: false });
        }
      } catch (error) {
        alert(error.response?.data?.message || "Failed to resend OTP.");
        this.setState({ loading: false });
      }
    }
  };

  toggleProfileMenu = () => {
    this.setState((prevState) => ({
      isProfileMenuOpen: !prevState.isProfileMenuOpen,
    }));
  };

  toggleMobileMenu = () => {
    this.setState((prevState) => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen,
      isProfileMenuOpen: false,
    }));
  };

  openAuthModal = (e) => {
    if (e) e.preventDefault();
    this.setState({
      isAuthModalOpen: true,
      isProfileMenuOpen: false,
      isMobileMenuOpen: false,
      authStep: 'phone',
      phoneNumber: '',
    });
  };

  closeAuthModal = () => {
    this.setState({ isAuthModalOpen: false, isCountryDropdownOpen: false });
    if (this.timerInterval) clearInterval(this.timerInterval);
  };

  // --- MODE SWITCH & REDIRECT LOGIC ---
  handleModeSwitch = (newMode) => {
    if (this.state.menuMode === newMode) return;

    this.setState({ isSwitchingMode: true, targetMode: newMode });

    setTimeout(() => {
      this.setState({
        menuMode: newMode,
        isSwitchingMode: false,
        targetMode: null
      });

      // Redirect based on target mode
      const redirectUrl = newMode === 'host' ? '/mylisting' : '/searchresultmobile';
      if (this.props.router?.navigate) {
        this.props.router.navigate(redirectUrl);
      } else {
        window.location.href = redirectUrl;
      }
    }, 1000);
  };

  handlePhoneSubmit = async () => {
    const { phoneNumber, countryCode } = this.state;
    if (!phoneNumber || phoneNumber.length < 5) {
      alert("Please enter a valid phone number.");
      return;
    }

    this.setState({ loading: true });
    const fullPhone = countryCode + phoneNumber;

    try {
      const res = await axios.post("/customer/send-otp", { phone: fullPhone });
      if (res.data.status === 'success') {
        this.setState({ authStep: 'otp', loading: false });
      } else {
        alert(res.data.message || "Something went wrong");
        this.setState({ loading: false });
      }
    } catch (error) {
      alert(error.response?.data?.message || "Failed to send OTP. Please try again.");
      this.setState({ loading: false });
    }
  };

  handleOtpChange = (index, value) => {
    if (isNaN(value)) return;

    const newOtp = [...this.state.otp];
    newOtp[index] = value;
    this.setState({ otp: newOtp });

    if (value !== '' && index < 5) {
      this.otpRefs[index + 1].current.focus();
    }
  };

  handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !this.state.otp[index] && index > 0) {
      this.otpRefs[index - 1].current.focus();
    }
  };

  handleOtpSubmit = async () => {
    const { phoneNumber, countryCode, otp } = this.state;
    const otpString = otp.join('');

    if (otpString.length < 4) {
      alert("Please enter a valid OTP.");
      return;
    }

    this.setState({ loading: true });
    const fullPhone = countryCode + phoneNumber;

    try {
      const res = await axios.post("/customer/verify-otp", {
        phone: fullPhone,
        otp: otpString
      });

      if (res.data.status === 'success') {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        localStorage.setItem("web_user_id", res.data.user.id);

        this.setState({
          isLoggedIn: true,
          isAuthModalOpen: false,
          otp: ['', '', '', '', '', ''],
          loading: false,
          isProfileMenuOpen: false,
          isMobileMenuOpen: false
        });
        if (this.timerInterval) clearInterval(this.timerInterval);
      }
    } catch (error) {
      alert(error.response?.data?.message || "Invalid OTP or expired.");
      this.setState({ loading: false });
    }
  };

  handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('web_user_id');
    this.setState({
      isLoggedIn: false,
      isProfileMenuOpen: false,
      isMobileMenuOpen: false
    });
  };

  toggleCountryDropdown = () => {
    this.setState((prevState) => ({
      isCountryDropdownOpen: !prevState.isCountryDropdownOpen,
    }));
  };

  selectCountry = (code, flag) => {
    this.setState({
      countryCode: code,
      selectedFlag: flag,
      isCountryDropdownOpen: false,
      countrySearch: ''
    });
  };

  renderPhoneStep() {
    const { countryCode, selectedFlag, isCountryDropdownOpen, countrySearch, phoneNumber, loading } = this.state;

    const countries = [
      { name: "Afghanistan", code: "+93", flag: "🇦🇫" },
      { name: "Albania", code: "+355", flag: "🇦🇱" },
      { name: "Algeria", code: "+213", flag: "🇩🇿" },
      { name: "Argentina", code: "+54", flag: "🇦🇷" },
      { name: "Australia", code: "+61", flag: "🇦🇺" },
      { name: "Austria", code: "+43", flag: "🇦🇹" },
      { name: "Bangladesh", code: "+880", flag: "🇧🇩" },
      { name: "Barbados", code: "+1", flag: "🇧🇧" },
      { name: "Belarus", code: "+375", flag: "🇧🇾" },
      { name: "Belgium", code: "+32", flag: "🇧🇪" },
      { name: "Brazil", code: "+55", flag: "🇧🇷" },
      { name: "Canada", code: "+1", flag: "🇨🇦" },
      { name: "China", code: "+86", flag: "🇨🇳" },
      { name: "France", code: "+33", flag: "🇫🇷" },
      { name: "Germany", code: "+49", flag: "🇩🇪" },
      { name: "India", code: "+91", flag: "🇮🇳" },
      { name: "Italy", code: "+39", flag: "🇮🇹" },
      { name: "Japan", code: "+81", flag: "🇯🇵" },
      { name: "Malaysia", code: "+60", flag: "🇲🇾" },
      { name: "Nepal", code: "+977", flag: "🇳🇵" },
      { name: "Pakistan", code: "+92", flag: "🇵🇰" },
      { name: "Saudi Arabia", code: "+966", flag: "🇸🇦" },
      { name: "Singapore", code: "+65", flag: "🇸🇬" },
      { name: "Sri Lanka", code: "+94", flag: "🇱🇰" },
      { name: "Thailand", code: "+66", flag: "🇹🇭" },
      { name: "UAE", code: "+971", flag: "🇦🇪" },
      { name: "United Kingdom", code: "+44", flag: "🇬🇧" },
      { name: "United States", code: "+1", flag: "🇺🇸" },
      { name: "Vietnam", code: "+84", flag: "🇻🇳" }
    ];

    const filteredCountries = countries.filter(c =>
      c.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
      c.code.includes(countrySearch)
    );

    return (
      <div className="bk-fade-in">
        <div className="bk-auth-top-bar">
          <h3>Log in or Sign up</h3>
          <button className="bk-close-bar-btn" onClick={this.closeAuthModal}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>

        <div className="bk-auth-step-container">
          <div className="bk-auth-header">
            <div className="bk-logo">
              <Link to="/">
                <img src={bookly} alt="Bookly" style={{ width: "220px", marginLeft: "-35px" }} />
              </Link>
            </div>
            <h2>Welcome to Bookly</h2>
            <p>Log in or create an account to book your next stay.</p>
          </div>

          <div className="bk-input-group">
            <label>Phone Number</label>
            <div className="bk-phone-input-wrapper">
              <div className="bk-country-selector" onClick={this.toggleCountryDropdown}>
                <span className="bk-flag">{selectedFlag}</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 9l6 6 6-6" /></svg>
              </div>

              <div className="bk-phone-prefix">{countryCode}</div>
              <input
                type="tel"
                placeholder="Phone Number"
                value={phoneNumber}
                onChange={(e) => this.setState({ phoneNumber: e.target.value })}
                disabled={loading}
              />

              {isCountryDropdownOpen && (
                <div className="bk-country-dropdown">
                  <div className="bk-country-search">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                    <input
                      type="text"
                      placeholder="Search country or code"
                      value={countrySearch}
                      onChange={(e) => this.setState({ countrySearch: e.target.value })}
                    />
                  </div>
                  <ul className="bk-country-list">
                    {filteredCountries.map((c, i) => (
                      <li key={i} onClick={() => this.selectCountry(c.code, c.flag)}>
                        <span className="bk-list-flag">{c.flag}</span>
                        <span className="bk-list-name">{c.name}</span>
                        <span className="bk-list-code">{c.code}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>

          <button
            className="bk-btn-primary"
            disabled={!phoneNumber || loading}
            onClick={this.handlePhoneSubmit}>
            {loading ? "Processing..." : "Continue"}
          </button>

          <p className="bk-terms-text">
            By continuing, you agree to our <Link to="/TermsandConditions" onClick={this.closeAuthModal}><strong>Terms</strong></Link> and <Link to="/PrivacyPolicy" onClick={this.closeAuthModal}><strong>Privacy</strong></Link>.
          </p>
        </div>
      </div>
    );
  }

  renderOtpStep() {
    const { countryCode, phoneNumber, otp, timer, loading } = this.state;

    return (
      <div className="bk-fade-in">
        <div className="bk-auth-top-bar">
          <button className="bk-back-bar-btn" onClick={() => this.setState({ authStep: 'phone' })}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
          </button>
          <h3>Log in or Sign up</h3>
          <div style={{ width: '28px' }}></div>
        </div>

        <div className="bk-auth-step-container">
          <div className="bk-otp-body">
            <p className="bk-otp-subtitle">We've sent a code to</p>
            <div className="bk-otp-target">
              <strong>{countryCode} {phoneNumber}</strong>
              <button className="bk-edit-btn" onClick={() => this.setState({ authStep: 'phone' })}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                Edit
              </button>
            </div>

            <div className="bk-otp-inputs">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={this.otpRefs[index]}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => this.handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => this.handleOtpKeyDown(index, e)}
                  className={digit ? 'bk-filled' : ''}
                  disabled={loading}
                />
              ))}
            </div>

            <div className="bk-resend-container">
              {timer > 0 ? (
                <p className="bk-resend-text">Resend OTP in {timer}s</p>
              ) : (
                <p className="bk-resend-text bk-active-resend" onClick={this.handleResendOtp}>
                  Resend OTP
                </p>
              )}
            </div>

            <button className="bk-btn-primary" onClick={this.handleOtpSubmit} disabled={loading}>
              {loading ? "Verifying..." : "Submit OTP"}
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderMenuContent() {
    const { isLoggedIn } = this.state;
    const closeMenus = () => this.setState({ isProfileMenuOpen: false, isMobileMenuOpen: false });

    if (!isLoggedIn) {
      return (
        <>
          <div className="bk-dropdown-item" onClick={this.openAuthModal}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#004bb4" strokeWidth="2"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line></svg>
            <span>Log in or Sign up</span>
          </div>
          <Link to="/blogs" className="bk-dropdown-item" onClick={closeMenus}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>
            <span>Blogs</span>
          </Link>
          <Link to="/contact" className="bk-dropdown-item" onClick={closeMenus}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
            <span>Help Center</span>
          </Link>
          <Link to="/about" className="bk-dropdown-item" onClick={closeMenus}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
            <span>About Us</span>
          </Link>
        </>
      );
    }

    return (
      <>
        <Link to="/dashboard" className="bk-dropdown-item" onClick={closeMenus}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#004bb4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
          <span>Account</span>
        </Link>

        <Link to="/chat" className="bk-dropdown-item" onClick={closeMenus}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
          <span>Messages</span>
        </Link>

        <Link to="/blogs" className="bk-dropdown-item" onClick={closeMenus}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>
          <span>Blogs</span>
        </Link>

        <Link to="/contact" className="bk-dropdown-item" onClick={closeMenus}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
          <span>Help Center</span>
        </Link>

        <Link to="/about" className="bk-dropdown-item" onClick={closeMenus}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
          <span>About Us</span>
        </Link>

        <div className="bk-dropdown-item text-danger" onClick={this.handleLogout}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
          <span>Logout</span>
        </div>
      </>
    );
  }

  render() {
    const { isProfileMenuOpen, isMobileMenuOpen, isAuthModalOpen, isLoggedIn, menuMode, isSwitchingMode, targetMode } = this.state;

    const menus = [
      { name: "Home", path: "/" },
      { name: "Blogs", path: "/blogs" },
      { name: "About Us", path: "/about" },
      { name: "Help Center", path: "/contact" },
    ];

    return (
      <>
        <header className="bk-header">
          <div className="bk-header-container">
            <div className="bk-logo">
              <Link to="/">
                <img src={bookly} alt="Bookly" style={{ width: "200px", marginLeft: "-35px" }} />
              </Link>
            </div>

            <nav className="bk-desktop-nav">
              <ul>
                {menus.map((menu) => (
                  <li key={menu.path}>
                    <NavLink
                      to={menu.path}
                      end={menu.path === "/"}
                      className={({ isActive }) => (isActive ? "bk-active" : "")}
                    >
                      {({ isActive }) => (
                        <>
                          {isActive && <span className="bk-active-dot"></span>}
                          {menu.name}
                        </>
                      )}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="bk-profile-section bk-desktop-only">
              <button className="bk-menu-toggle-btn" onClick={this.toggleProfileMenu}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={isLoggedIn ? '#004bb4' : 'currentColor'} strokeWidth="2"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
              </button>

              {isProfileMenuOpen && (
                <div className="bk-profile-dropdown">
                  {this.renderMenuContent()}
                </div>
              )}
            </div>

            <div className="bk-mobile-menu-toggle bk-mobile-only">
              <button className="bk-menu-toggle-btn" onClick={this.toggleMobileMenu}>
                {isMobileMenuOpen ? (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                ) : (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
                )}
              </button>
            </div>
          </div>

          {isMobileMenuOpen && (
            <div className="bk-mobile-side-dropdown bk-mobile-only bk-fade-in">
              <div className="bk-mobile-action-list">
                {this.renderMenuContent()}
              </div>
            </div>
          )}
        </header>

        {/* Dynamic Mobile Bottom Navigation based on Mode */}
        {menuMode === 'guest' ? (
          <nav className="bk-mobile-bottom-nav">
            <NavLink to="/searchresultmobile" end className={({ isActive }) => `bk-mobile-nav-item ${isActive ? "bk-active" : ""}`}>
              <div className="bk-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </div>
              <span>Explore</span>
            </NavLink>

            <NavLink to="/booking" className={({ isActive }) => `bk-mobile-nav-item ${isActive ? "bk-active" : ""}`}>
              <div className="bk-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                </svg>
              </div>
              <span>Booking</span>
            </NavLink>

            <NavLink to="/chat" className={({ isActive }) => `bk-mobile-nav-item ${isActive ? "bk-active" : ""}`}>
              <div className="bk-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
              </div>
              <span>Inbox</span>
            </NavLink>

            <NavLink to="/profilemobile" className={({ isActive }) => `bk-mobile-nav-item ${isActive ? "bk-active" : ""}`}>
              <div className="bk-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <span>Profile</span>
            </NavLink>

            <div className="bk-mobile-nav-item" style={{ cursor: 'pointer' }} onClick={() => this.handleModeSwitch('host')}>
              <div className="bk-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
              </div>
              <span>Host</span>
            </div>
          </nav>
        ) : (
          <nav className="bk-mobile-bottom-nav">
            <NavLink to="/reservation" end className={({ isActive }) => `bk-mobile-nav-item ${isActive ? "bk-active" : ""}`}>
              <div className="bk-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
              </div>
              <span>Reservation</span>
            </NavLink>

            <NavLink to="/chats" className={({ isActive }) => `bk-mobile-nav-item ${isActive ? "bk-active" : ""}`}>
              <div className="bk-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
              </div>
              <span>Inbox</span>
            </NavLink>

            <NavLink to="/mylisting" className={({ isActive }) => `bk-mobile-nav-item ${isActive ? "bk-active" : ""}`}>
              <div className="bk-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="8" y1="6" x2="21" y2="6"></line>
                  <line x1="8" y1="12" x2="21" y2="12"></line>
                  <line x1="8" y1="18" x2="21" y2="18"></line>
                  <line x1="3" y1="6" x2="3.01" y2="6"></line>
                  <line x1="3" y1="12" x2="3.01" y2="12"></line>
                  <line x1="3" y1="18" x2="3.01" y2="18"></line>
                </svg>
              </div>
              <span>My Listing</span>
            </NavLink>

            <NavLink to="/calendar" className={({ isActive }) => `bk-mobile-nav-item ${isActive ? "bk-active" : ""}`}>
              <div className="bk-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <span>Calendar</span>
            </NavLink>

            <div className="bk-mobile-nav-item" style={{ cursor: 'pointer' }} onClick={() => this.handleModeSwitch('guest')}>
              <div className="bk-icon-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <span>Guest</span>
            </div>
          </nav>
        )}

        {isAuthModalOpen && (
          <div className="bk-modal-overlay" onClick={this.closeAuthModal}>
            <div className="bk-modal-box" onClick={(e) => e.stopPropagation()}>
              {this.state.authStep === 'phone' ? this.renderPhoneStep() : this.renderOtpStep()}
            </div>
          </div>
        )}

        {/* --- Loading Overlay for Mode Switch --- */}
        {isSwitchingMode && (
          <div className="bk-mode-switch-overlay">
            <div className="bk-mode-switch-modal">
              <div className="bk-spinner-container">
                <div className="bk-spinner-large" />
                <img src={loading} alt="Loading" className="bk-spinner-image" />
              </div>
              <h3>Switching to {targetMode === 'host' ? 'Host' : 'Guest'} Mode...</h3>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(BooklyHeader);

